// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11HQ_","label":"styles_label__2Zta3"};